import { render, staticRenderFns } from "./DialogService.vue?vue&type=template&id=313420e4&scoped=true"
import script from "./DialogService.vue?vue&type=script&lang=ts"
export * from "./DialogService.vue?vue&type=script&lang=ts"
import style0 from "./DialogService.vue?vue&type=style&index=0&id=313420e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313420e4",
  null
  
)

export default component.exports